import React, { useEffect, useState } from "react";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useI18n } from "@/context/I18nContext";
import api from "@/lib/api";

export default function Faq() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta("FAQ", L("Domande frequenti sul servizio di recupero accesso wallet di Recovers Crypto.", "Frequently asked questions about Recovers Crypto wallet access recovery.", "Häufig gestellte Fragen zum Wallet-Zugriffs-Wiederherstellungsdienst von Recovers Crypto."));
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/content/faq").then(({ data }) => setFaqs(data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHero eyebrow="FAQ" title={L("Domande frequenti", "Frequently asked questions", "Häufig gestellte Fragen")}
        subtitle={L("Le risposte alle domande più comuni sul nostro servizio, sui costi e sulla sicurezza.", "Answers to the most common questions about our service, costs and security.", "Antworten auf die häufigsten Fragen zu unserem Dienst, den Kosten und der Sicherheit.")} />
      <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-20">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border-white/10">
              <AccordionTrigger className="text-left text-white hover:text-cyanx" data-testid={`faq-item-${f.id}`}>{f.question}</AccordionTrigger>
              <AccordionContent className="text-slate-400 leading-relaxed">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
